/*jshint devel:true */

  // ! Google Analytics
  // Event tracking

/* Go jQuery, plugins are stored in plugins.js - note we're using noConflict version here */
(function($) {
$(function() {
  
  // Select a target in a state and record an interaction event.
  
  // Umbrella interactions
  
  // Operates umbrella drawer
  
  $('#umbrella a[href="#umbrella-basket"]').on('click', function() {
    
    if ($('#umbrella-basket').hasClass('js-selected-target')) {
      ga('send','event','Umbrella','Open','Umbrella Basket Drawer',1);
    } else {
      ga('send','event','Umbrella','Close','Umbrella Basket Drawer',1);
    }
    
  });
  
  $('#umbrella-basket a.close').on('click', function() {
    ga('send','event','Umbrella','Close','Umbrella Basket Drawer (Close Link)',1);
  });
  
  
  // Links to the basket page
  $('#umbrella form[action="/cart"] .btn').on('click', function() {
  
    if ($(this).hasClass('quick-basket')) {
      ga('send','event','Go To Basket','Click','Umbrella (Quick Button)',1);
    } else {
      ga('send','event','Go To Basket','Click','Umbrella (In Drawer)',1);
    }
    
  });
  
  // Umbrella check out
  $('#umbrella-basket input[name="checkout"]').on('click', function() {
    ga('send','event','Go To Checkout','Click','Umbrella Basket Drawer',1);
  });

  // Umbrella add/remove product
  $('#umbrella form[action="/cart/add"] button').on('click', function() {
    
    if ($(this).hasClass('btn-remove')) {
      ga('send','event','Cart Items','Removed','Umbrella Basket Drawer',1);
    } else {
      ga('send','event','Cart Items','Added','Umbrella Basket Drawer',1);
    }
    
  });
  
  
  // Currency and VAT
  
  // Currency settings
  
  $('select[name="currencies"]').on('change', function() {
    
    ga('send','event','Currency','Changed To',$(this).val(),1);
    
    if ($(this).parents('#umbrella').length == 1) {
      ga('send','event','Currency','Changed','Umbrella Basket',1);
    } 
    else if ($(this).parents('#product').length == 1) {
      ga('send','event','Currency','Changed','Product',1);
    }
    else if ($(this).parents('.basket-page').length == 1) {
      ga('send','event','Currency','Changed','Basket Page',1);
    }
    
  });
  
  // Currency settings
  
  $('select[name="vat-setting"]').on('change', function() {
    
    ga('send','event','VAT Setting','Changed To',$(this).val(),1);
    
    if ($(this).parents('#umbrella').length == 1) {
      ga('send','event','VAT Setting','Changed','Umbrella Basket',1);
    } 
    else if ($(this).parents('#product').length == 1) {
      ga('send','event','VAT Setting','Changed','Product',1);
    }
    else if ($(this).parents('.basket-page').length == 1) {
      ga('send','event','VAT Setting','Changed','Basket Page',1);
    }
    
  });
  
  // Measurement settings
  
  $('select[name="sizechart-units"]').on('change', function() {

    ga('send','event','Sizechart Units','Changed To',$(this).val(),1);
    
  });
  
  
  // Collections
  
  // collection sorting
  
  $('.collection-sort a').on('click', function() {
     ga('send','event','Collection','Sort',$(this).attr('href').replace('?sort_by=', ''),1);
  });
   
   
  // Navigation
  
  // main nav
  $('nav.browse a').on('click', function() {
    
    if ($(this).hasClass('js-selected-trigger')) {
      ga('send','event','Main Navigation','Open',$(this).text(),1);
    } else {
      ga('send','event','Main Navigation','Close',$(this).text(),1);
    }
    
  });
  
  // home nav
  $('nav.home-nav a').on('click', function() {
    ga('send','event','Home Navigation','Click',$(this).text(),1);    
  });
  
  // buying links on product page
  $('nav.buying a').on('click', function() {
    
    if ($(this).hasClass('js-selected-trigger')) {
      ga('send','event','Buying Navigation','Open',$(this).text(),1);
    } else {
      ga('send','event','Buying Navigation','Close',$(this).text(),1);
    }
    
  }); 
  
  // Banners
  
  // newsletter signup
  
  $('footer .newsletter-signup a').on('click', function() {
    ga('send','event','Footer Banner','Click',$(this).text(),1);    
  });
  
  // header message
  $('.global-header-message a').on('click', function() {
    ga('send','event','Header Message','Click',$(this).text(),1);    
  });
  
  
  
});
})(jQuery);

